var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 448 448",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M277.251,372.440 L277.251,325.977 C183.620,325.273 191.364,312.601 191.364,190.106 C191.364,95.771 230.084,76.059 248.388,76.059 C280.771,76.059 261.763,137.306 324.419,137.306 C364.547,137.306 384.963,107.034 384.963,69.723 C384.963,29.595 355.395,0.731 311.043,0.731 C263.171,0.731 218.820,32.411 191.364,77.467 L191.364,14.811 L0.581,14.811 L0.581,61.275 C78.725,61.979 74.501,78.171 74.501,176.730 L74.501,189.402 C74.501,314.009 78.725,325.273 0.581,325.977 L0.581,372.440 L277.251,372.440 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.9fcd69f5d3c55a8d4f1ccec465d532f1.svg";
export { ForwardRef as ReactComponent };